import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './ContributionLayout.module.css';

type ContributionLayoutProps = {
  /** Steget i bidraget (1 eller 2). Takkesiden har ikke steg. */
  step?: 1 | 2;
  children: ReactNode;
};

/** Felles ramme for fokusområde, valg av bidrag og takk: tonet bue og smal kolonne */
export const ContributionLayout = ({ step, children }: ContributionLayoutProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div aria-hidden="true" className={classes.backdrop} />
      <div className={classes.content}>
        {step && (
          <div className={classes.steps}>
            <span className={classes.stepLabel}>{t('contribution.step', { current: step, total: 2 })}</span>
            <span aria-hidden="true" className={classes.stepBars}>
              <span data-active="true" />
              <span data-active={step === 2} />
            </span>
          </div>
        )}
        {children}
      </div>
    </>
  );
};
